import { CardTitle } from '../StyledComponents/Card';
import { CardContent } from '@mui/material';
import { ButtonContainer } from '../StyledComponents/Buttons';
import { ButtonRules, StyledButton } from '@canopysecurity/component-library';
import { StyledModal } from '../Components/StyledModal';

interface OnSubmitModalInput {
  isVisible: boolean;
  onClose: () => void;
  title: string;
  message: string;
}

export const OnSubmitModal = (props: OnSubmitModalInput) => {
  const { isVisible, onClose, title, message } = props;
  const handleClose = async () => {
    onClose();
  };
  return (
    <StyledModal
      isOpen={isVisible}
      onRequestClose={onClose}
      label="on-submit-modal"
    >
      <CardTitle>{title}</CardTitle>
      <CardContent>{message}</CardContent>
      <ButtonContainer>
        <StyledButton onPress={handleClose} buttonRules={ButtonRules.primaryA}>
          Close
        </StyledButton>
      </ButtonContainer>
    </StyledModal>
  );
};
